
import { Loja } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from './alert.service';
import {environment} from '../../environments/environment'

@Injectable({
    providedIn: 'root'
})

export class LojaService {

    getLojaByRegional(idRegional: string): Observable<any> {
        return this.http.get<Loja[]>(`${environment.apiUrl}/Loja/GetByRegional/`+idRegional);
    }

    getByPerfilLoginRegional(idRegional: string): Observable<any> {
        return this.http.get<Loja[]>(`${environment.apiUrl}/Loja/GetByPerfilLoginRegional/`+idRegional);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }

}
